export const CARE_CHAT_MESSAGE_TYPE = {
  TEXT: 'text',
  FILE: 'file',
  PICTURE: 'picture',
  VIDEO: 'video',
  VOICE: 'voice',
  AUDIO: 'audio'
} as const

export type CareChatMessageType = typeof CARE_CHAT_MESSAGE_TYPE[keyof typeof CARE_CHAT_MESSAGE_TYPE]

export const CARE_CHAT_SENDER_TYPE = {
  USER: 'user',
  MANAGER: 'manager'
} as const

export type CareChatSenderType = typeof CARE_CHAT_SENDER_TYPE[keyof typeof CARE_CHAT_SENDER_TYPE]

export const CARE_CHAT_SEND_STATUS = {
  SENDING: 'sending',
  RETRYING: 'retrying',
  SENT: 'sent',
  FAILED: 'failed'
} as const

export type CareChatSendStatus = typeof CARE_CHAT_SEND_STATUS[keyof typeof CARE_CHAT_SEND_STATUS]

export interface CareChatAttachment {
  url: string
  thumbnailUrl?: string
  fileName?: string
  fileSize?: number
  mediaType?: CareChatMessageType
}

export interface CareChatMessage {
  id?: string
  conversationId?: string
  text?: string
  type?: CareChatMessageType
  senderType?: CareChatSenderType
  senderName?: string
  mediaUrl?: string
  thumbnailUrl?: string
  fileName?: string
  fileSize?: number
  timestamp?: number
  quotedMessageId?: string
  quotedMessageText?: string
  sendStatus?: CareChatSendStatus
  localFilePath?: string
  localUid?: string
}

export interface CareChatOutgoingAttachment {
  type?: string
  url?: string
  thumbnail?: string
  file_name?: string
  file_size?: number
  [key: string]: unknown
}

export interface CareChatConversation {
  id: string
  externalId?: string
  unreadCount: number
  lastMessageTimestamp?: number
}

export const CARE_CHAT_CONNECTION_STATUS = {
  IDLE: 'idle',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  ERROR: 'error',
  DISCONNECTED: 'disconnected'
} as const

export type CareChatConnectionStatus = typeof CARE_CHAT_CONNECTION_STATUS[keyof typeof CARE_CHAT_CONNECTION_STATUS]

export interface CareChatTypingEvent {
  conversationId: string
  expiredAt: number
}

export interface CareChatInitParams {
  userId: string
  name?: string
  phone?: string
  email?: string
}

export interface CareChatInitResult {
  chatId: string
  conversationIdList: string[]
  customerUuid: string
  backendUrl: string
}
